module.exports = __webpack_public_path__ + "static/media/kyro.98775238.svg";